import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import Flex from "../Flex";
import { ActionsButton, ActionsButtonProps } from "./ActionsButton";

const commonArgs: ActionsButtonProps = {
    opened: false,
    trackName: "button",
    loading: false,
    title: "Button CTA",
    onClick: action("clicked")
};

export default {
    title: "common/Buttons/ActionsButton",
    component: ActionsButton,
    args: commonArgs
} as ComponentMeta<typeof ActionsButton>;

const Template: ComponentStory<typeof ActionsButton> = args => {
    return (
        <Flex spacing={1} alignItems="center">
            <ActionsButton {...args} size="lg" />
            <ActionsButton {...args} size="md" />
            <ActionsButton {...args} size="sm" />
        </Flex>
    );
};

export const Text = Template.bind({});

export const Opened = Template.bind({});
Opened.args = {
    opened: true
};

export const TextLoading = Template.bind({});
TextLoading.args = {
    loading: true
};

export const DestructiveText = Template.bind({});
DestructiveText.args = {
    destructive: true
};

export const DestructiveTextLoading = Template.bind({});
DestructiveTextLoading.args = {
    ...DestructiveText.args,
    loading: true
};

export const WithTooltip = Template.bind({});
WithTooltip.args = {
    tooltip: "Tooltip text"
};
